/* Shared journey and motion behavior. Cloud navigation keeps its own spring. */
(() => {
  if (window.caNubeExperienceReady) return;
  window.caNubeExperienceReady = true;
  const storage = {
    read(key) { try { return JSON.parse(sessionStorage.getItem(key)); } catch { return null; } },
    write(key, value) { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch {} },
    remove(key) { try { sessionStorage.removeItem(key); } catch {} }
  };
  const validReturn = value => value && Number.isFinite(value.top) && value.top >= 0
    && typeof value.path === 'string' && /^\/(?!\/)/.test(value.path)
    && Date.now() - value.time < 30 * 60 * 1000;
  let returning = storage.read('nube:catalog-return');
  if (!validReturn(returning) || location.hash !== '#chia') returning = null;
  storage.remove('nube:catalog-return');
  let returnFocused = false;
  window.caNubeRestoreCatalog = column => {
    if (!returning || column.dataset.caMobileColumn !== '2') return;
    column.scrollTo({
      top: Math.min(returning.top, Math.max(0, column.scrollHeight - column.clientHeight)),
      behavior: 'instant'
    });
    if (!returnFocused) {
      const card = [...column.querySelectorAll('a[data-ca-sabor-card]')].find(a => a.pathname === returning.product);
      requestAnimationFrame(() => card?.focus({ preventScroll: true }));
      returnFocused = true;
    }
  };
  for (const type of ['pointerdown', 'touchstart', 'wheel', 'keydown']) {
    window.addEventListener(type, () => { returning = null; }, { passive: true, capture: true });
  }
  document.addEventListener('click', event => {
    const card = event.target.closest('a[data-ca-sabor-card]');
    if (!card || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const column = card.closest('[data-ca-mobile-column="2"]');
    if (!column) return;
    storage.write('nube:catalog-position', {
      path: location.pathname, top: column.scrollTop, product: card.pathname, time: Date.now()
    });
  });
  document.querySelectorAll('[data-ca-catalog-return]').forEach(link => {
    const saved = storage.read('nube:catalog-position');
    if (validReturn(saved)) link.href = `${saved.path}#chia`;
    link.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const current = storage.read('nube:catalog-position');
      if (validReturn(current)) storage.write('nube:catalog-return', current);
    });
  });

  const loops = [...document.querySelectorAll('.ca-product__ticker-track, .ca-product__reviews-track, .ca-nube-sabores-marquee__track')];
  if (loops.length && 'IntersectionObserver' in window) {
    const visible = new Set();
    const updateLoops = () => loops.forEach(node => node.classList.toggle('ca-motion-paused', document.hidden || !visible.has(node)));
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target));
      updateLoops();
    });
    loops.forEach(node => observer.observe(node));
    document.addEventListener('visibilitychange', updateLoops);
  }

  const root = document.querySelector('[data-ca-product-root]');
  const bar = root?.querySelector('[data-ca-sticky-purchase]');
  const form = root?.querySelector('[data-ca-product-form]');
  const main = form?.querySelector('.ca-product__buy');
  if (!bar || !form || !main || !('IntersectionObserver' in window)) return;
  const button = bar.querySelector('button');
  const mobile = matchMedia('(max-width: 900px)');
  const footerButton = root.querySelector('.ca-product__footer-actions button');
  const error = form.querySelector('[data-ca-product-form-error]');
  let frame = 0;
  let lastError = '';
  const setText = (selector, text) => {
    const node = bar.querySelector(selector);
    if (node.textContent !== text) node.textContent = text;
  };
  const inView = node => {
    const rect = node?.getBoundingClientRect();
    return rect && rect.bottom > 0 && rect.top < innerHeight;
  };
  const update = () => {
    frame = 0;
    const busy = form.dataset.caSubmitting === 'true';
    const flavor = root.querySelector(`[data-ca-flavor-data="${root.dataset.currentFlavor || root.dataset.initialFlavor}"]`);
    setText('[data-ca-sticky-flavor]', flavor?.dataset.name || 'chia mix');
    setText('[data-ca-sticky-price]', form.querySelector('[data-ca-price]')?.textContent || '');
    setText('[data-ca-sticky-label]', busy ? 'añadiendo…' : main.disabled ? 'próximamente' : mobile.matches ? 'añadir' : 'añadir al carrito');
    button.disabled = main.disabled || busy || root.classList.contains('is-flavor-locked');
    button.setAttribute('aria-busy', String(busy));
    const editing = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
    const show = main.getBoundingClientRect().bottom <= 0
      && !document.body.classList.contains('ca-nube-cart-is-open') && !editing && !inView(footerButton);
    if (bar.contains(document.activeElement) && !show && !document.body.classList.contains('ca-nube-cart-is-open')) {
      (inView(footerButton) ? footerButton : main).focus({ preventScroll: true });
    }
    bar.classList.toggle('is-visible', show);
    bar.inert = !show;
    bar.setAttribute('aria-hidden', String(!show));
    if (error && !error.hidden && error.textContent && error.textContent !== lastError) {
      lastError = error.textContent;
      error.tabIndex = -1;
      error.scrollIntoView({ block: 'center', behavior: 'auto' });
      error.focus({ preventScroll: true });
    } else if (error?.hidden) lastError = '';
  };
  const queue = () => { if (!frame) frame = requestAnimationFrame(update); };
  button.addEventListener('click', () => {
    if (!button.disabled) form.requestSubmit(main);
  });
  const intersection = new IntersectionObserver(queue, { threshold: [0, 1] });
  intersection.observe(main);
  if (footerButton) intersection.observe(footerButton);
  new MutationObserver(queue).observe(form, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'data-ca-submitting', 'hidden'] });
  new MutationObserver(queue).observe(root, { attributes: true, attributeFilter: ['class', 'data-current-flavor'] });
  new MutationObserver(queue).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  document.addEventListener('focusin', queue);
  document.addEventListener('focusout', queue);
  window.addEventListener('resize', queue, { passive: true });
  mobile.addEventListener('change', queue);
  bar.hidden = false;
  if ('ResizeObserver' in window) {
    new ResizeObserver(() => root.style.setProperty('--ca-sticky-purchase-height', `${bar.offsetHeight}px`)).observe(bar);
  }
  update();
})();
